import type { RNG } from "../core/RNG";
import type { SkillDef } from "./Skills";
import type { Combatant } from "./Stats";

/**
 * Applies a skill outside of battle and returns the line to show. Battle uses
 * its own richer path; this covers herbs, healing spells and revival at camp.
 */
export function applySkillOutOfBattle(
  skill: SkillDef,
  user: Combatant,
  target: Combatant,
  rng: RNG,
): string {
  switch (skill.kind) {
    case "heal": {
      if (!target.alive) return `${target.name} is beyond the reach of that.`;
      const variance = skill.variance ?? 0.15;
      const amount = target.heal(Math.round((skill.power ?? 0) * rng.float(1 - variance, 1 + variance)));
      return amount > 0
        ? `${target.name} recovers ${amount} HP.`
        : `${target.name} is already in perfect health.`;
    }
    case "revive": {
      if (target.alive) return `${target.name} is not in need of that.`;
      target.hp = Math.max(1, Math.round(target.maxHp * (skill.power ?? 0.5)));
      return `${target.name} returns to life!`;
    }
    case "damage":
      return `${user.name} has no one to use ${skill.name} on.`;
    case "status":
    case "flee":
      return `Nothing happens.`;
  }
}

/** Whether a skill can be used from the field menu at all. */
export function isFieldUsable(skill: SkillDef): boolean {
  return skill.field === true;
}
